import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import RechargeStep2 from 'pages/Recharge/partials/Step2/RechargeStep2.component';
import { DepositMode } from 'services/recharges/recharges.config';
import { z } from 'zod';

const recharegeStep2SearchSchema = z.object({
  formIdFromUrl: z.string().optional(),
  amount: z.number().optional(),
  promoCode: z.string().optional(),
  method: z.enum(DepositMode),
  selectBonus: z.string().optional(),
  showPdvDepositModal: z.boolean().optional(),
});

export const Route = createFileRoute('/_auth/ricarica/step2')({
  component: RechargeStep2,
  validateSearch: zodValidator(recharegeStep2SearchSchema),
});
